// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O56O","largestCol":"styles_largestCol__JgBWH","smallestCol":"styles_smallestCol__3emKF"};